import React, { useState } from 'react'
import * as styles from './HoverCards.module.scss'
import ComponentTitleLockup, {
  ComponentTitleLockupProps
} from 'src/modules/molecules/component-title-lockup'

interface HoverCard {
  title: string
  comingSoon?: boolean
  paragraph?: string
  imageSrc?: string
  imageAlt?: string
  imgMaxWidth?: string
}

interface HoverCardsProps {
  titleLockupProps: ComponentTitleLockupProps
  cards: HoverCard[]
}

const HoverCards: React.FC<HoverCardsProps> = ({ titleLockupProps, cards }) => {
  const [activeIndex, setActiveIndex] = useState<number>(0)

  return (
    <div>
      <div className={styles.container}>
        <ComponentTitleLockup {...titleLockupProps} />
        <div className={styles.grid}>
          <div className={styles.cardContent}>
            <ul>
              <div
                className={styles.activeDot}
                style={{ transform: `translateY(${activeIndex * 480}%)` }}
              />
              {cards.map((card, index) => (
                <li
                  key={index}
                  onMouseEnter={() => setActiveIndex(index)}
                  className={activeIndex === index ? styles.active : ''}
                >
                  {card.title}
                </li>
              ))}
            </ul>
            {cards[activeIndex].paragraph && (
              <p>{cards[activeIndex].paragraph}</p>
            )}
          </div>
          <div className={styles.cardImg}>
            {cards.map(
              (card, index) =>
                card.imageSrc &&
                card.imageAlt && (
                  <img
                    key={index}
                    src={card.imageSrc}
                    alt={card.imageAlt}
                    className={`${activeIndex === index ? styles.visible : ''}`}
                  />
                )
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HoverCards

export const HoverCardsAlt: React.FC<HoverCardsProps> = ({
  titleLockupProps,
  cards
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(0)

  return (
    <div>
      <div className={styles.containerAlt}>
        <ComponentTitleLockup {...titleLockupProps} />
        <div className={styles.gridAlt}>
          <div className={styles.cardContentAlt}>
            <ul>
              <div
                className={styles.activeDot}
                style={{ transform: `translateY(${activeIndex * 480}%)` }}
              />
              {cards.map((card, index) => (
                <li
                  key={index}
                  onMouseEnter={() => setActiveIndex(index)}
                  className={activeIndex === index ? styles.active : ''}
                >
                  <div className='flex justify-between items-center gap-2 w-full'>
                    {card.title}
                    {/* show the following on hover of the li */}
                    {card.comingSoon && (
                      <span
                        className={
                          styles.comingSoonBadge +
                          ' bg-[var(--color-gray-100)] text-[var(--color-gray-800)] px-3 py-1 rounded-[2.5rem] text-sm text-center'
                        }
                      >
                        Coming soon
                      </span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
            {cards[activeIndex].paragraph && (
              <p>{cards[activeIndex].paragraph}</p>
            )}
          </div>
          <div className={styles.cardImgAlt}>
            {cards.map(
              (card, index) =>
                card.imageSrc &&
                card.imageAlt && (
                  <img
                    key={index}
                    src={card.imageSrc}
                    alt={card.imageAlt}
                    className={`${activeIndex === index ? styles.visible : ''}`}
                    style={{ maxWidth: card.imgMaxWidth || '75%' }}
                  />
                )
            )}
          </div>
        </div>

        {/* make mobiel version that just shows each title, descritpion, and image together each in its own card */}
        <div className={styles.mobileCards}>
          {cards.map((card, index) => (
            <>
              <div>
                <div className={styles.cardImgBg}>
                  <img src={card.imageSrc} alt={card.imageAlt} />
                </div>
                <div key={index} className={styles.mobileCard}>
                  <h4 className='title-h4 mb-4'>{card.title}</h4>
                  <p>{card.paragraph}</p>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  )
}
